import { Card, Colors, Heading, Icon, Text, type IconName } from '@amelio/ui-library';

export interface HeaderCard {
    icon: IconName;
    label: string;
    description: string;
}

interface HeaderProps {
    headerCards: HeaderCard[];
}

export const Header = ({ headerCards }: HeaderProps) => {
    return (
        <div className={'grid grid-cols-1 flex-row gap-5 md:grid-cols-2 lg:grid-cols-3'}>
            {headerCards.map((card) => (
                <Card
                    key={card.icon}
                    variant={'elevated'}
                    borderRadius={'xl'}
                    shadow={'none'}
                >
                    <div className={'flex flex-row items-center'}>
                        <div
                            className={
                                'bg-primary-50 flex aspect-square h-[40px] w-[40px] items-center justify-center rounded-[12px]'
                            }
                        >
                            <Icon
                                name={card.icon}
                                className={'h-[20px] w-[20px]'}
                                color={Colors.PRIMARY}
                            />
                        </div>

                        <Heading className={'ml-4 text-[18px]'}>{card.label}</Heading>
                    </div>

                    <Text
                        size={'small'}
                        className={'mt-3 text-base'}
                    >
                        {card.description}
                    </Text>
                </Card>
            ))}
        </div>
    );
};
